import React, { useCallback, useReducer } from 'react';
import { createWatchReducer } from './createWatchReducer';
import { CreateWatchContext, createWatchInitialState, TTypeOfModalWindow } from './createWatchContext';
import { CreateWatchActionTypes } from './createWatchActions';
import { IServerError, ISerialNumberExistsValidationError, ICreateWatch } from 'types';

export const CreateWatchState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createWatchReducer, createWatchInitialState);

	const changeSerialNumber = useCallback((value: string) => {
		dispatch({
			type: CreateWatchActionTypes.CHANGE_SERIAL_NUMBER,
			payload: {
				serialNumber: value,
			},
		});
	}, []);

	const setIDCustomer = useCallback((value: Nullable<string>) => {
		dispatch({
			type: CreateWatchActionTypes.SET_ID_CUSTOMER,
			payload: {
				IDSelectedCustomer: value,
			},
		});
	}, []);

	const setIDRestaurant = useCallback((value: Nullable<string>) => {
		dispatch({
			type: CreateWatchActionTypes.SET_ID_RESTAURANT,
			payload: {
				IDSelectedRestaurant: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: Nullable<ICreateWatch>) => {
		dispatch({
			type: CreateWatchActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfModalWindow) => {
		dispatch({
			type: CreateWatchActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const showErrorModalWithInfo = useCallback((value: Nullable<IServerError<ISerialNumberExistsValidationError>>) => {
		dispatch({
			type: CreateWatchActionTypes.SHOW_ERROR_MODAL_WITH_INFO,
			payload: {
				errorResponseData: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateWatchActionTypes.RESET_FIELDS }), []);

	return (
		<CreateWatchContext.Provider
			value={{
				changeSerialNumber,
				setIDCustomer,
				setIDRestaurant,
				setDataForSubmit,
				changeTypeOfModalWindow,
				showErrorModalWithInfo,
				resetFields,
				serialNumber: state.serialNumber,
				IDSelectedCustomer: state.IDSelectedCustomer,
				IDSelectedRestaurant: state.IDSelectedRestaurant,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
				errorResponseData: state.errorResponseData,
			}}>
			{children}
		</CreateWatchContext.Provider>
	);
};
